export const generateIssueLink = (projectId: string, issueId: string): string => {
  return `/issues?project=${projectId}&issue=${issueId}`;
};